import { RestaurantsListPreloader } from "./RestaurantsListPreloader";

export default RestaurantsListPreloader;
